import React from "react";

const ErrorView = ({ error }) => {
  // Show specific message for permission errors
  if (error?.name === "NotAllowedError") {
    return (
      <div>
        📷 Camera access denied
        <br />
        <br />
        Please enable camera permissions in your browser settings and try again.
      </div>
    );
  }

  // Show specific message for device unavailable errors
  if (error?.name === "NotFoundError" || error?.message?.includes("Device unavailable")) {
    return (
      <div>
        📷 No camera found
        <br />
        <br />
        Please connect a camera and try again.
      </div>
    );
  }

  // Default error message
  return (
    <div>
      Oh snap! Your browser failed to record your video.
      <br />
      <br />
      Please restart it and try again 👍
    </div>
  );
};

export default ErrorView;
